// removed by extract-text-webpack-plugin
module.exports = {"video":"video__video___1n_J8"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Pages/Media-recorder/video.scss
// module id = 135
// module chunks = 0